import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  blackJackCheckFairness,
  blackJackGameDoubleBet,
  blackJackGameHitBet,
  blackJackGamePlaceBet,
  blackJackGameSplitBet,
  blackJackGameStandBet,
  blackJackPlaceInsuranceBet,
  blackJackUnfinishedBet,
  blackJackUpdateCurrentHandStatus,
  getBlackJackGameBetHistory,
  getBlackJackHighRollerTransactionsService,
  getBlackJackTransactionsService,
  getMyBlackJackTransactionsService
} from 'games/BlackJack/services/blackjack.service'
import { plus } from 'number-precision'
import { openErrorToaster, openSuccessToaster } from 'utils/common-services/toaster.service'
import { setBlackjackWagered } from './blackjack.slice'
import { enqueueCreditWalletWaitQueue, debitBalance } from 'redux-store/redux/slices/auth.slice'
import { BET_RESULT } from 'utils/constants/index'

export const placedBetBlackjackGame = createAsyncThunk('blackjack-game/place-bet-blackjack', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackGamePlaceBet(payload)
    openSuccessToaster({ message: 'Bet Placed successfully' })
    if (res) {
      thunkApi.dispatch(setBlackjackWagered(Number(payload?.data?.betAmount)))
      thunkApi.dispatch(debitBalance(Number(res?.round?.mainBet?.betAmount)))
      if (res?.round?.mainBet?.result === BET_RESULT.WON) {
        thunkApi.dispatch(enqueueCreditWalletWaitQueue(Number(res?.round?.mainBet?.winningAmount)))
      }
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const hitBetBlackjackGame = createAsyncThunk('blackjack-game/hit-bet-blackjack', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackGameHitBet(payload)

    // Sum of all bets winningAmount
    if (res) {
      let winningAmount = 0
      const betTypes = ['mainBet', 'doubleBet', 'splitBet', 'insuranceBet']
      for (const betType of betTypes) {
        const bet = res?.[betType]
        if (bet?.result === BET_RESULT.WON) {
          winningAmount = plus(winningAmount, Number(bet.winningAmount || 0))
        }
      }
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(winningAmount))
    }

    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const standBetBlackjackGame = createAsyncThunk('blackjack-game/stand-bet-blackjack', async (_, thunkApi) => {
  try {
    const res = await blackJackGameStandBet({})
    // Sum of all bets winningAmount
    if (res) {
      let winningAmount = 0
      const betTypes = ['mainBet', 'doubleBet', 'splitBet', 'insuranceBet']
      for (const betType of betTypes) {
        const bet = res?.[betType]
        if (bet?.result === BET_RESULT.WON) {
          winningAmount = plus(winningAmount, Number(bet.winningAmount || 0))
        }
      }
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(winningAmount))
    }
    return res
  } catch (error) {
    openErrorToaster({ message: error[0]?.description })
    return thunkApi.rejectWithValue(error[0]?.description)
  }
})

export const splitBetBlackjackGame = createAsyncThunk('blackjack-game/split-bet-blackjack', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackGameSplitBet(payload)
    thunkApi.dispatch(setBlackjackWagered(parseFloat(res?.betAmount / 2).toFixed(2)))
    if (res) {
      thunkApi.dispatch(debitBalance(Number(res?.doubleBet?.betAmount)))
      // Sum of all bets winningAmount
      let winningAmount = 0
      const betTypes = ['mainBet', 'doubleBet', 'splitBet', 'insuranceBet']
      for (const betType of betTypes) {
        const bet = res?.[betType]
        if (bet?.result === BET_RESULT.WON) {
          winningAmount = plus(winningAmount, Number(bet.winningAmount || 0))
        }
      }
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(winningAmount))
    }
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const doubleBetBlackjackGame = createAsyncThunk('blackjack-game/double-bet-blackjack', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackGameDoubleBet(payload)
    thunkApi.dispatch(setBlackjackWagered(parseFloat(res?.betAmount / 2).toFixed(2)))
    if (res) {
      thunkApi.dispatch(debitBalance(Number(res?.doubleBet?.betAmount)))
      // Sum of all bets winningAmount
      let winningAmount = 0
      const betTypes = ['mainBet', 'doubleBet', 'splitBet', 'insuranceBet']
      for (const betType of betTypes) {
        const bet = res?.[betType]
        if (bet?.result === BET_RESULT.WON) {
          winningAmount = plus(winningAmount, Number(bet.winningAmount || 0))
        }
      }
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(winningAmount))
    }
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const betListBlackjackGame = createAsyncThunk('blackjack-game/bet-history-blackjack', async ({ params }, thunkApi) => {
  try {
    const res = await getBlackJackGameBetHistory(params)
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const unfinishedBetBlackjackGame = createAsyncThunk('blackjack-game/unfinished-bet-blackjack', async (_, thunkApi) => {
  try {
    const res = await blackJackUnfinishedBet()
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const placeInsuranceBlackjackGame = createAsyncThunk('blackjack-game/place-insurance', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackPlaceInsuranceBet(payload)
    thunkApi.dispatch(setBlackjackWagered(parseFloat(res?.betAmount / 2).toFixed(2)))
    if (res) {
      thunkApi.dispatch(debitBalance(Number(res?.doubleBet?.betAmount)))
      // Sum of all bets winningAmount
      let winningAmount = 0
      const betTypes = ['mainBet', 'doubleBet', 'splitBet', 'insuranceBet']
      for (const betType of betTypes) {
        const bet = res?.[betType]
        if (bet?.result === BET_RESULT.WON) {
          winningAmount = plus(winningAmount, Number(bet.winningAmount || 0))
        }
      }
      thunkApi.dispatch(enqueueCreditWalletWaitQueue(winningAmount))
    }
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const updateCurrentStatusBlackjackGame = createAsyncThunk('blackjack-game/update-current-hand-status', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackUpdateCurrentHandStatus(payload)
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const checkFairnessBlackjackGame = createAsyncThunk('blackjack-game/check-fairness', async ({ payload }, thunkApi) => {
  try {
    const res = await blackJackCheckFairness(payload)
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getBlackJackHighRollerTransactions = createAsyncThunk(
  'fetch/blackjack-transactions-high-roller',
  async (data, thunkApi) => {
    try {
      const res = await getBlackJackHighRollerTransactionsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBlackJackTransactions = createAsyncThunk(
  'fetch/blackjack-game-transactions',
  async (data, thunkApi) => {
    try {
      const res = await getMyBlackJackTransactionsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getBlackJackTransactions = createAsyncThunk(
  'fetch/get-blackjack-transactions',
  async (data, thunkApi) => {
    try {
      const res = await getBlackJackTransactionsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
